import { createContext, useContext, type ReactNode } from 'react';
import { type User } from '@/domain/authentication';

interface UserContextValue {
    user: User | null;
}

const UserContext = createContext<UserContextValue | undefined>(undefined);

export function UserProvider({ user, children }: { user: User | null; children: ReactNode }) {
    return (
        <UserContext.Provider value={{ user }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser(): UserContextValue {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}
